// extracted by mini-css-extract-plugin
module.exports = {"img":"PhotoImg_img__GN7D1"};